import React, { useContext } from 'react'
import styles from './WorkingStatus.module.css'
import { ChoicesButton } from '../../../Common/CtaButton/ChoicesButton'
import { StepContext } from '../../../Context/StepContext'
import { useAbTestGtm } from '../../../utils/abTest'

export const WorkingStatus = () => {
    const { handleNext, updateFormData, formData } = useContext(StepContext)

    const handleSelect = (status) => {
        updateFormData('workingStatus', status)
        handleNext()
    }

    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                <h1
                    data-view-label={dataViewLabel('EF_StepForm_Step1-現在の状況')}
                    className={styles.titleText}
                >
                    Q.現在の状況はいかがですか？
                </h1>
            </div>
            <div className={styles.selectionWrapper}>
                <ChoicesButton
                    imageSrc='/entry_form_slide_app/steps/step1/people-cook.png'
                    imageAlt='料理人イラスト'
                    dataClickLabel={dataClickLabel('EF_StepForm_Step1-現在の状況-在籍中')}
                    onClick={() => handleSelect('就業中')}
                    selected={formData.workingStatus === '就業中'}
                />
                <ChoicesButton
                    imageSrc='/entry_form_slide_app/steps/step1/people-normal.png'
                    imageAlt='男性イラスト'
                    dataClickLabel={dataClickLabel('EF_StepForm_Step1-現在の状況-離職中')}
                    onClick={() => handleSelect('離職中')}
                    selected={formData.workingStatus === '離職中'}
                />
            </div>
        </div>
    )
}
